/* eslint-disable prettier/prettier */
// import { store } from '../App'
import Constants from '../constants';
declare const window: any;
let adminUrl = '',
  pokerWebUrl = '',
  miniGamesWebUrl = '',
  adminCloudFrontUrl = '',
  fantasySportsImage = '',
  geoLocationKey = '',
  appId = '',
  bannerUrl = '';
const {
  REACT_APP_ADMIN_URL = '',
  REACT_APP_POKER_WEB = '',
  REACT_APP_MINI_GAMES_WEB = '',
  REACT_APP_ADMIN_CLOUD_FRONT_URL = '',
  REACT_APP_FANTASY_SPORTS_IMAGE = '',
  REACT_APP_GEO_LOCATION_KEY = '',
  REACT_APP_BUILD_VERSION = 1,
  REACT_APP_APP_ID = '',
  REACT_APP_BANNER = ''
} = process.env;
adminUrl = REACT_APP_ADMIN_URL;
pokerWebUrl = REACT_APP_POKER_WEB;
miniGamesWebUrl = REACT_APP_MINI_GAMES_WEB;
adminCloudFrontUrl = REACT_APP_ADMIN_CLOUD_FRONT_URL;
fantasySportsImage = REACT_APP_FANTASY_SPORTS_IMAGE;
geoLocationKey = REACT_APP_GEO_LOCATION_KEY;
bannerUrl = REACT_APP_BANNER;
appId = REACT_APP_APP_ID;
window.BUILD_VERSION = REACT_APP_BUILD_VERSION;
const isReleaseBuild = process.env.NODE_ENV === 'production';

export default class Connection {
  static getBaseUrl(isCloudFrontURL: any) {
    let baseURL = '';
    baseURL = `${isCloudFrontURL ? adminCloudFrontUrl : adminUrl}`;
    return baseURL;
  }

  static isShowServerSwitcher() {
    return false;
  }

  static getServerType() {
    return 'store.getState().app.serverType';
  }

  static getServerTypeByBaseURL() {
    const baseUrl = Connection.getBaseUrl(false);
    return baseUrl.includes('dev')
      ? 'development'
      : baseUrl.includes('staging')
      ? 'staging'
      : 'production';
  }

  static getAppId() {
    return appId;
  }

  static getPlayerImageURL(playerId: any, gameType: any) {
    const gType =
      gameType === Constants.GameType.FANTASY_KABADDI
        ? 'kabaddi'
        : gameType === Constants.GameType.FANTASY_FOOTBALL
        ? 'football'
        : 'cricket';
    return `${fantasySportsImage}/${gType}/Player/${playerId}.png`;
  }

  static getMatchTeamURL(matchTeamId: any, gameType: any) {
    const gType =
      gameType === Constants.GameType.FANTASY_KABADDI
        ? 'kabaddi'
        : gameType === Constants.GameType.FANTASY_FOOTBALL
        ? 'football'
        : 'cricket';
    return `${fantasySportsImage}/${gType}/MatchTeam/${matchTeamId}.png`;
  }

  static getCloudFrontUrl() {
    return fantasySportsImage;
  }

  static getBannerUrl() {
    return bannerUrl;
  }

  static isLiveCredentials() {
    if (!this.isShowServerSwitcher()) return true;
    if (this.getServerType() === 'production') return true;
    else return false;
  }

  static isBaseAdminUrlSame(baseUrlsObj: any) {
    try {
      return baseUrlsObj.admin.restUrl === adminUrl;
    } catch (error) {
      return false;
    }
  }
  static getPokerWebURL() {
    return pokerWebUrl;
  }

  static getMiniGamesWebURL() {
    return miniGamesWebUrl;
  }

  static getGeoLocationKey() {
    return geoLocationKey;
  }

  static getFreshChatDomain() {
    return process.env.REACT_APP_FRESH_CHAT_DOMAIN;
  }

  static getFreshChatAppId() {
    return process.env.REACT_APP_FRESH_CHAT_APP_ID;
  }

  static getFreshChatAppKey() {
    return process.env.REACT_APP_FRESH_CHAT_APP_KEY;
  }
  static getFreshChatAppToken() {
    return process.env.REACT_APP_FRESH_CHAT_TOKEN;
  }
  static getPaymentRedirectURL() {
    const baseUrl = Connection.getBaseUrl(false);
    return baseUrl.includes('api-dev.gamio-services.net') && isReleaseBuild
      ? 'https://play-dev1.igamio.com'
      : baseUrl.includes('api.gamio-services.net') && isReleaseBuild
      ? 'https://play-dev1.igamio.com'
      : 'http://localhost:3000';
  }
}
